<template>
  <v-form class='createWpsAsmeForm' v-model='valid' ref='createWpsAsmeForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <div class="logo_box text-center">
            <v-img :src="$getCompanyData().url"></v-img>
          </div>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <h4>Welding Procedure Specification</h4>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <v-row class="d-none">
            <v-col cols='12' md='6' sm='6' xs='12'>
              <module-prefix :module="'wps_asme'" :prefix.sync="wpsAsme.prefix" :no.sync="wpsAsme.no" v-if="!wpsAsme.id"/>
              <v-text-field
                v-model="wpsAsme.prefix"
                label='Prefix'
                placeholder='Prefix'
                v-if="wpsAsme.id"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols='12' md='6' sm='6' xs='12'>
              <v-text-field
              v-model='wpsAsme.no'
              :error-messages='error.no'
              label='No'
              placeholder='No'
              readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-text-field
            label='Procedure No'
            placeholder='Procedure No'
            :value="bindWpsAsmeNo"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <v-text-field
            v-model='wpsAsme.company_name'
            :error-messages='error.company_name'
            label='Company Name'
            placeholder='Company Name'
          ></v-text-field>
          <v-textarea
            v-model="wpsAsme.company_address"
            :error-messages='error.company_address'
            label="Company Address"
            placeholder="Company Address"
            rows="3"
          ></v-textarea>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <searchable-select :value.sync="wpsAsme.referred_standard_id" :options="{ url: 'referred_standard', label: 'Refrerred Standard'}" :errorMessage="error.referred_standard_id" :selectedData="{id: wpsAsme.referred_standard_id, text: wpsAsme.referred_standard_name}"/>
          <searchable-select :value.sync="wpsAsme.pqr_id" :options="{ url: 'welding_procedure', label: 'Supporting Pqrs', data: {'type' : ['pqr_aws','pqr_asme']} }" :errorMessage="error.pqr_id" :selectedData="{id: wpsAsme.pqr_id, text: wpsAsme.pqr_name}"/>
          <searchable-select :value.sync="wpsAsme.wptwpr_id" :options="{ url: 'welding_process', label: 'Welding Process', multiple: true, returnType: 'object' }" :errorMessage="error.wptwpr_id" :selectedData="wpsAsme.wptwpr_id" :addNew="{right: 'edit_welding_process', module: 'weldingProcess', title: 'Create Welding Process'}"/>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <v-text-field
            v-model="wpsAsme.rev_date"
            :error-messages="error.rev_date"
            type="date"
            label="Rev Date"
          ></v-text-field>
          <v-text-field
            v-model='wpsAsme.rev_no'
            :error-messages='error.rev_no'
            label='Rev No'
            placeholder='Rev No'
          ></v-text-field>
          <searchable-select :value.sync="wpsAsme.wptwt_id" :options="{ url: 'welding_type', label: 'Welding Type', multiple: true, returnType: 'object' }" :errorMessage="error.wptwt_id" :selectedData="wpsAsme.wptwt_id" :addNew="{right: 'edit_welding_type', module: 'weldingType', title: 'Create Welding Type'}"/>
        </v-col>
      </v-row>
      <hr />
      <h4 class="text-center">Joint Design (QW-402)</h4>
      <v-row>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <v-text-field
            v-model='wpsAsme.joint_design'
            :error-messages='error.joint_design'
            label='Joint Design'
            placeholder='Joint Design'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
         <v-checkbox
           v-model="wpsAsme.joint_backing"
           label="Joint Backing"
         ></v-checkbox>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <v-text-field
            v-model='wpsAsme.joint_backing_material'
            :error-messages='error.joint_backing_material'
            label='Joint Backing Material Type'
            placeholder='Joint Backing Material Type'
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" xs="12">
          <p>Joint Drawings</p>
          <input type="file" class="d-none" ref="file_input_join_drawing" @change="fileChangeEvent" @click="resetImageUploader" multiple>
          <div class="upload_container">
            <v-row v-for="(image, i) in images" :key="i">
              <v-col cols='12' md='4' sm='12' xs='12'>
                <div class="position-relative">
                  <v-img
                    :src="`${image.url}`"
                  ></v-img>
                  <div class="wl-close-icon text-center" @click="removeImage(i)">
                    <v-icon size="16" color="white">mdi-delete</v-icon>
                  </div>
                </div>
              </v-col>
              <v-col cols='12' md='8' sm='12' xs='12'>
               <v-row>
                <v-col cols='12' md='2' sm='6' xs='12'>
                  <v-text-field
                  v-model='image.param_a'
                  label='A'
                  placeholder='A'
                  ></v-text-field>
                </v-col>
                <v-col cols='12' md='2' sm='6' xs='12'>
                  <v-text-field
                  v-model='image.param_b'
                  label='B'
                  placeholder='B'
                  ></v-text-field>
                </v-col>
                <v-col cols='12' md='2' sm='6' xs='12'>
                  <v-text-field
                  v-model='image.param_c'
                  label='C'
                  placeholder='C'
                  ></v-text-field>
                </v-col>
                <v-col cols='12' md='2' sm='6' xs='12'>
                  <v-text-field
                  v-model='image.param_d'
                  label='D'
                  placeholder='D'
                  ></v-text-field>
                </v-col>
                <v-col cols='12' md='2' sm='6' xs='12'>
                  <v-text-field
                  v-model='image.param_e'
                  label='E'
                  placeholder='E'
                  ></v-text-field>
                </v-col>
                <v-col cols='12' md='2' sm='6' xs='12'>
                  <v-text-field
                  v-model='image.param_f'
                  label='F'
                  placeholder='F'
                  ></v-text-field>
                </v-col>
              </v-row>
              </v-col>
            </v-row>
          </div>
          <div class="text-right">
            <v-btn color="primary" small class="ma-1" @click="loadGallery = true">Select Image</v-btn>
            <v-btn color="primary" small class="ma-1" @click="uploadImage">Upload Image</v-btn>
          </div>
        </v-col>
      </v-row>
      <hr />
      <h4 class="text-center">Base Metals (QW-403)</h4>
      <v-row v-if="error.base_metal ? error.base_metal[0] : false">
        <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
          <span class="red--text">{{ error.base_metal ? error.base_metal[0] : '' }}</span>
        </v-col>
      </v-row>
      <v-row v-for="(item, index) in wpsAsme.base_metal" :key="index" class="pt-5">
        <v-col cols="12" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
              <v-text-field
                label="Base Metal"
                placeholder="Base Metal"
                v-model="wpsAsme.base_metal[index].base_metal"
                :error-messages="error[`base_metal.${index}.base_metal`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
              <v-text-field
                label="Name / Grade"
                placeholder="Name / Grade"
                v-model="wpsAsme.base_metal[index].grade"
                :error-messages="error[`base_metal.${index}.grade`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Material Specification"
                placeholder="Material Specification"
                v-model="wpsAsme.base_metal[index].material_specification"
                :error-messages="error[`base_metal.${index}.material_specification`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="P No"
                placeholder="P No"
                v-model="wpsAsme.base_metal[index].p_no"
                :error-messages="error[`base_metal.${index}.p_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Group No"
                placeholder="Group No"
                v-model="wpsAsme.base_metal[index].group_no"
                :error-messages="error[`base_metal.${index}.group_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Thickness"
                placeholder="Thickness"
                v-model="wpsAsme.base_metal[index].thickness"
                :error-messages="error[`base_metal.${index}.thickness`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Groove Thickness Range"
                placeholder="Groove Thickness Range"
                v-model="wpsAsme.base_metal[index].groove_thickness_range"
                :error-messages="error[`base_metal.${index}.groove_thickness_range`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Fillet Thickness Range"
                placeholder="Fillet Thickness Range"
                v-model="wpsAsme.base_metal[index].fillet_thickness_range"
                :error-messages="error[`base_metal.${index}.fillet_thickness_range`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Pipe Diameter Range"
                placeholder="Pipe Diameter Range"
                v-model="wpsAsme.base_metal[index].pipe_diameter_range"
                :error-messages="error[`base_metal.${index}.pipe_diameter_range`]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="1" md="1" sm="12" xs="12" align-self="center" class="pt-0">
          <v-row>
            <v-col cols="12" class="text-center">
              <v-icon @click="removeBaseMetal(index)" v-if="!$vuetify.breakpoint.mdAndDown">mdi-delete-circle</v-icon>
              <v-btn @click="removeBaseMetal(index)" small block v-else>Delete</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="wpsAsme.base_metal.length < 2">
        <v-col cols="12" md="12" sm="12" xs="12" class="pb-5">
          <v-btn color="primary" class="mr-2" @click="addBaseMetal" small :block="$vuetify.breakpoint.mdAndDown">Add New</v-btn>
        </v-col>
      </v-row>
      <hr />
      <h4 class="text-center">Filler Metals (QW-404)</h4>
      <v-row v-if="error.filler_metal ? error.filler_metal[0] : false">
        <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
          <span class="red--text">{{ error.filler_metal ? error.filler_metal[0] : '' }}</span>
        </v-col>
      </v-row>
      <v-row v-for="(item, ind) in wpsAsme.filler_metal" :key="`filler_metal_${ind}`" class="pt-5">
        <v-col cols="12" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
              <searchable-select :value.sync="wpsAsme.filler_metal[ind].welding_process_id" :options="{ url: 'welding_process', label: 'Welding Process' }" :errorMessage="error[`filler_metal.${ind}.welding_process_id`]" :selectedData="bindWeldingProcess(ind)" :key="ind"/>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
              <v-text-field
              label="F no"
              placeholder="F no"
              v-model="wpsAsme.filler_metal[ind].f_no"
              :error-messages="error[`filler_metal.${ind}.f_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="A no"
              placeholder="A no"
              v-model="wpsAsme.filler_metal[ind].a_no"
              :error-messages="error[`filler_metal.${ind}.a_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Spec No(SFA)"
              placeholder="Spec No(SFA)"
              v-model="wpsAsme.filler_metal[ind].spec_no"
              :error-messages="error[`filler_metal.${ind}.spec_no`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Aws Class"
              placeholder="Aws Class"
              v-model="wpsAsme.filler_metal[ind].aws_class"
              :error-messages="error[`filler_metal.${ind}.aws_class`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Filler Size"
              placeholder="Filler Size"
              v-model="wpsAsme.filler_metal[ind].filler_size"
              :error-messages="error[`filler_metal.${ind}.filler_size`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Deposited Weld Metal Thickness"
              placeholder="Deposited Weld Metal Thickness"
              v-model="wpsAsme.filler_metal[ind].deposited_weld_metal_thickness"
              :error-messages="error[`filler_metal.${ind}.deposited_weld_metal_thickness`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Groove"
              placeholder="Groove"
              v-model="wpsAsme.filler_metal[ind].groove"
              :error-messages="error[`filler_metal.${ind}.groove`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Fillet"
              placeholder="Fillet"
              v-model="wpsAsme.filler_metal[ind].fillet"
              :error-messages="error[`filler_metal.${ind}.fillet`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
              label="Electrode Flux Class"
              placeholder="Electrode Flux Class"
              v-model="wpsAsme.filler_metal[ind].electrode_flux_class"
              :error-messages="error[`filler_metal.${ind}.electrode_flux_class`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-textarea
              v-model="wpsAsme.filler_metal[ind].remarks"
              :error-messages='error[`filler_metal.${ind}.remarks`]'
              label="Remarks"
              placeholder="Remarks"
              rows="1"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="1" md="1" sm="12" xs="12" align-self="center" class="pt-0">
          <v-row>
            <v-col cols="12" class="text-center">
              <v-icon @click="removeFillerMetal(ind)" v-if="!$vuetify.breakpoint.mdAndDown">mdi-delete-circle</v-icon>
              <v-btn @click="removeFillerMetal(ind)" small block v-else>Delete</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" class="pb-5">
          <v-btn color="primary" class="mr-2" @click="addFillerMetal" small :block="$vuetify.breakpoint.mdAndDown">Add New</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Positions (QW-405)</h4>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='wpsAsme.position_of_groove'
              :error-messages='error.position_of_groove'
              label='Positions Of Groove'
              placeholder='Positions Of Groove'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='wpsAsme.position_of_fillet'
              :error-messages='error.position_of_fillet'
              label='Positions Of Fillet'
              placeholder='Positions Of Fillet'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='wpsAsme.welding_progression'
              :error-messages='error.welding_progression'
              label='Welding Progression'
              placeholder='Welding Progression'
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Preheat (QW-406)</h4>
          <v-row >
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='wpsAsme.preheat_temperature_min'
                :error-messages='error.preheat_temperature_min'
                label='Preheat Temperature Min'
                placeholder='Preheat Temperature Min'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='wpsAsme.preheat_temperature_max'
                :error-messages='error.preheat_temperature_max'
                label='Preheat Temperature Max'
                placeholder='Preheat Temperature Max'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='wpsAsme.interpass_temperature_min'
                :error-messages='error.interpass_temperature_min'
                label='Interpass Temperature Min'
                placeholder='Interpass Temperature Min'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='wpsAsme.interpass_temperature_max'
                :error-messages='error.interpass_temperature_max'
                label='Interpass Temperature Max'
                placeholder='Interpass Temperature Max'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-textarea
                v-model="wpsAsme.preheat_maintenance"
                :error-messages='error.preheat_maintenance'
                label="Preheat Maintenance"
                placeholder="Preheat Maintenance"
                rows="1"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <hr />
      <v-row class="mt-2">
        <v-col cols="12" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Post Heat Treatment (QW-407)</h4>
          <v-row >
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='wpsAsme.postheat_temperature_min'
                :error-messages='error.postheat_temperature_min'
                label='Postheat Temperature Min'
                placeholder='Postheat Temperature Min'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='wpsAsme.postheat_temperature_max'
                :error-messages='error.postheat_temperature_max'
                label='Postheat Temperature Max'
                placeholder='Postheat Temperature Max'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='wpsAsme.time_min'
                :error-messages='error.time_min'
                label='Time Min'
                placeholder='Time Min'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='wpsAsme.time_max'
                :error-messages='error.time_max'
                label='Time Max'
                placeholder='Time Max'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-textarea
                v-model="wpsAsme.postheat_remark"
                :error-messages='error.postheat_remark'
                label="Remarks"
                placeholder="Remarks"
                rows="1"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Gas (QW-408)</h4>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='wpsAsme.electrode_flux'
              :error-messages='error.electrode_flux'
              label='Sheilding Gas'
              placeholder='Sheilding Gas'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='wpsAsme.composition_per'
              :error-messages='error.composition_per'
              label='Composition %'
              placeholder='Composition %'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='wpsAsme.flow_rate'
              :error-messages='error.flow_rate'
              label='Flow Rate'
              placeholder='Flow Rate'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
              v-model='wpsAsme.gas_backing'
              :error-messages='error.gas_backing'
              label='Gas Backing'
              placeholder='Gas Backing'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
              v-model='wpsAsme.nozzle_size'
              :error-messages='error.nozzle_size'
              label='Nozzle Size'
              placeholder='Nozzle Size'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-text-field
              v-model='wpsAsme.trailing_shielding_gas'
              :error-messages='error.trailing_shielding_gas'
              label='Trailing Shielding Gas'
              placeholder='Trailing Shielding Gas'
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <hr />
      <h4 class="text-center mt-2">Electrical Charecterstics (QW-409)</h4>
      <v-row class="mt-2">
        <v-col cols="12" md="3" sm="3" xs="12">
          <v-text-field
            v-model='wpsAsme.tungsten_type'
            :error-messages='error.tungsten_type'
            label='Tungsten Type'
            placeholder='Tungsten Type'
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="3" xs="12">
          <v-text-field
          v-model='wpsAsme.tungsten_size'
          :error-messages='error.tungsten_size'
          label='Tungsten Size'
          placeholder='Tungsten Size'
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="3" xs="12">
          <v-text-field
          v-model='wpsAsme.torch_angle'
          :error-messages='error.torch_angle'
          label='Torch Angle'
          placeholder='Torch Angle'
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="3" xs="12">
          <v-text-field
            v-model='wpsAsme.current'
            :error-messages='error.current'
            label='Current'
            placeholder='Current'
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12">
          <v-text-field
            v-model='wpsAsme.mode_of_metal_transfer'
            :error-messages='error.mode_of_metal_transfer'
            label='Model Of Metal Transfer'
            placeholder='Model Of Metal Transfer'
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8" sm="6" xs="12">
          <v-textarea
            v-model="wpsAsme.electrical_char_remark"
            :error-messages='error.electrical_char_remark'
            label="Remarks"
            placeholder="Remarks"
            rows="1"
          ></v-textarea>
        </v-col>
      </v-row>
      <h4 class="text-center mt-2">Technique (QW-410)</h4>
      <v-row class="mt-2">
        <v-col cols="12" md="6" sm="12" xs="12">
          <v-text-field
            v-model='wpsAsme.weave_bead'
            :error-messages='error.weave_bead'
            label='String or Weave Bead'
            placeholder='String or Weave Bead'
          ></v-text-field>
          <v-text-field
            v-model='wpsAsme.gas_cup_size'
            :error-messages='error.gas_cup_size'
            label='Orifice / Gas Cup Size'
            placeholder='Orifice / Gas Cup Size'
          ></v-text-field>
          <v-text-field
            v-model='wpsAsme.cleaning'
            :error-messages='error.cleaning'
            label='Inital and Interpass Cleaning (Brushing,Grinding)'
            placeholder='Inital and Interpass Cleaning (Brushing,Grinding)'
          ></v-text-field>
          <v-text-field
            v-model='wpsAsme.back_gouging_method'
            :error-messages='error.back_gouging_method'
            label='Method Of Back Gouging'
            placeholder='Method Of Back Gouging'
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" sm="12" xs="12">
          <v-text-field
            v-model='wpsAsme.oscillation'
            :error-messages='error.oscillation'
            label='Oscillation'
            placeholder='Oscillation'
          ></v-text-field>
          <v-text-field
            v-model='wpsAsme.contact_tube_work_distance'
            :error-messages='error.contact_tube_work_distance'
            label='Contact Tube Work Distance'
            placeholder='Contact Tube Work Distance'
          ></v-text-field>
          <v-autocomplete
            v-model="wpsAsme.pass_perside"
            item-value="id"
            :items="[ {id: 'single', text: 'Single'}, {id: 'multiple', text: 'Multiple'}]"
            :error-messages='error.pass_perside'
            label='Multiple Or Single Pass (perside)'
            placeholder='Multiple Or Single Pass (perside)'
          ></v-autocomplete>
          <v-text-field
            v-model='wpsAsme.electrode'
            :error-messages='error.electrode'
            label='Multiple Or Single Electrodes'
            placeholder='Multiple Or Single Electrodes'
          ></v-text-field>
          <v-row>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='wpsAsme.peening'
                :error-messages='error.peening'
                label='Peening'
                placeholder='Peening'
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6" xs="12">
              <v-text-field
                v-model='wpsAsme.electrode_spacing'
                :error-messages='error.electrode_spacing'
                label='Electrode Spacing'
                placeholder='Electrode Spacing'
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <hr />
      <h4 class="text-center mt-2">Welding Parameters</h4>
      <v-row v-if="error.welding_parameter ? error.welding_parameter[0] : false">
        <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
          <span class="red--text">{{ error.welding_parameter ? error.welding_parameter[0] : '' }}</span>
        </v-col>
      </v-row>
      <v-row v-for="(item, ind) in wpsAsme.welding_parameter" :key="`welding_parameter_${ind}`" class="pt-5">
          <v-col cols="12" lg="11" md="11" sm="12" xs="12" class="py-0">
            <v-row>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
                <searchable-select :value.sync="wpsAsme.welding_parameter[ind].welding_process_id" :options="{ url: 'welding_process', label: 'Welding Process' }" :errorMessage="error[`welding_parameter.${ind}.welding_process_id`]" :selectedData="bindWpmWeldingProcess(ind)" :key="ind"/>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
                <v-text-field
                label="Weld Layer"
                placeholder="Weld Layer"
                v-model="wpsAsme.welding_parameter[ind].weld_layer"
                :error-messages="error[`welding_parameter.${ind}.weld_layer`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Filler Class"
                placeholder="Filler Class"
                v-model="wpsAsme.welding_parameter[ind].filler_class"
                :error-messages="error[`welding_parameter.${ind}.filler_class`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Filler Size"
                placeholder="Filler Size"
                v-model="wpsAsme.welding_parameter[ind].filler_size"
                :error-messages="error[`welding_parameter.${ind}.filler_size`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0">
                <searchable-select :value.sync="wpsAsme.welding_parameter[ind].polarity_id" :options="{ url: 'polarity', label: 'Polarity' }" :errorMessage="error[`welding_parameter.${ind}.polarity_id`]" :selectedData="bindWpmPolarity(ind)" :key="ind" :disabled="wpsAsme.welding_parameter[ind].id !== undefined ? true : false"/>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Current(A)"
                placeholder="Min Current(A)"
                v-model="wpsAsme.welding_parameter[ind].min_current"
                :error-messages="error[`welding_parameter.${ind}.min_current`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Current(A)"
                placeholder="Max Current(A)"
                v-model="wpsAsme.welding_parameter[ind].max_current"
                :error-messages="error[`welding_parameter.${ind}.max_current`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Voltage(V)"
                placeholder="Min Voltage(V)"
                v-model="wpsAsme.welding_parameter[ind].min_voltage"
                :error-messages="error[`welding_parameter.${ind}.min_voltage`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Voltage(V)"
                placeholder="Max Voltage(V)"
                v-model="wpsAsme.welding_parameter[ind].max_voltage"
                :error-messages="error[`welding_parameter.${ind}.max_voltage`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Travel Speed"
                placeholder="Min Travel Speed"
                v-model="wpsAsme.welding_parameter[ind].min_travel_speed"
                :error-messages="error[`welding_parameter.${ind}.min_travel_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Travel Speed"
                placeholder="Max Travel Speed"
                v-model="wpsAsme.welding_parameter[ind].max_travel_speed"
                :error-messages="error[`welding_parameter.${ind}.max_travel_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Feed Speed"
                placeholder="Min Feed Speed"
                v-model="wpsAsme.welding_parameter[ind].min_feed_speed"
                :error-messages="error[`welding_parameter.${ind}.min_feed_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Feed Speed"
                placeholder="Max Feed Speed"
                v-model="wpsAsme.welding_parameter[ind].max_feed_speed"
                :error-messages="error[`welding_parameter.${ind}.max_feed_speed`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Min Flow Rate"
                placeholder="Min Flow Rate"
                v-model="wpsAsme.welding_parameter[ind].min_flowrate"
                :error-messages="error[`welding_parameter.${ind}.min_flowrate`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <v-text-field
                label="Max Flow Rate"
                placeholder="Max Flow Rate"
                v-model="wpsAsme.welding_parameter[ind].max_flowrate"
                :error-messages="error[`welding_parameter.${ind}.max_flowrate`]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="1" md="1" sm="12" xs="12" align-self="center" class="pt-0">
            <v-row>
              <v-col cols="12" class="text-center">
                <v-icon @click="removeWeldingParameter(ind)" v-if="!$vuetify.breakpoint.mdAndDown">mdi-delete-circle</v-icon>
                <v-btn @click="removeWeldingParameter(ind)" small block v-else>Delete</v-btn>
              </v-col>
            </v-row>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" class="pb-5">
          <v-btn color="primary" class="mr-2" @click="addWeldingParameter" small :block="$vuetify.breakpoint.mdAndDown">Add New</v-btn>
        </v-col>
      </v-row>
      <hr />
      <v-row class="mt-2">
        <v-col cols="12" md="6" sm="12" xs="12">
          <v-text-field
            v-model='wpsAsme.prepared_by'
            :error-messages='error.prepared_by'
            label='Prepared By'
            placeholder='Prepared By'
          ></v-text-field>
          <v-textarea
            v-model="wpsAsme.prepared_by_sign"
            :error-messages='error.prepared_by_sign'
            label="Prepared By Signature"
            placeholder="Prepared By Signature"
            rows="2"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="6" sm="12" xs="12">
          <v-text-field
            v-model='wpsAsme.approved_by'
            :error-messages='error.approved_by'
            label='Approved By'
            placeholder='Approved By'
          ></v-text-field>
          <v-textarea
            v-model="wpsAsme.approved_by_sign"
            :error-messages='error.approved_by_sign'
            label="Approved By Signature"
            placeholder="Approved By Signature"
            rows="2"
          ></v-textarea>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12' >
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="wpsAsme.status" row class='radio-with-lable'>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
    <ImageGallery v-if="loadGallery" :isOpen="loadGallery" @closeGallery="loadGallery=false;" @selectedImage="getSelectedImage"></ImageGallery>
  </v-form>
</template>

<script>
import ImageGallery from '../../components/imageGallery.vue'
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  components: {
    ImageGallery,
  },
  computed: {
    bindWpsAsmeNo () {
      return this.wpsAsme.prefix + ((this.wpsAsme.no ? this.wpsAsme.no : '').toString().padStart(4, '0'))
    }
  },
  created () {
    const companyData = this.$getCompanyData()
    this.wpsAsme.company_name = companyData.name
    this.wpsAsme.company_address = companyData.address
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.edit_id = id
      const url = 'getWeldingProcedureById/'
      this.getDataById(url, id)
    } else {
      this.edit_id = undefined
      const storageData = localStorage.getItem('clone_data')
      if (storageData) {
        const _storageData = JSON.parse(storageData)
        const url = 'getWeldingProcedureCloneById/'
        this.getDataById(url, _storageData.module_id)
      }
      localStorage.removeItem('clone_data')
    }
    this.wpsAsme.base_metal.push(
      { base_metal: '', grade: '', material_specification: '', p_no: '', group_no: '', thickness: '', groove_thickness_range: '', fillet_thickness_range: '', pipe_diameter_range: '' },
    )
    this.wpsAsme.welding_parameter.push(
      { welding_process_id: {}, weld_layer: '', filler_class: '', filler_size: '', polarity_id: {}, min_current: '', max_current: '', min_voltage: '', max_voltage: '', min_travel_speed: '', max_travel_speed: '', min_feed_speed: '', max_feed_speed: '', min_flowrate: '', max_flowrate: '' }
    )
    this.wpsAsme.filler_metal.push(
      { welding_process_id: {}, f_no: '', a_no: '', spec_no: '', aws_class: '', filler_size: '', deposited_weld_metal_thickness: '', groove: '', fillet: '', electrode_flux_class: '', remarks: '' }
    )
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      wpsAsme: { prefix: '', no: '', status: 0, flux: 1, rev_no: 0, rev_date: new Date().toISOString().substr(0, 10), base_metal: [], filler_metal: [], welding_parameter: [] },
      error: {},
      images: [],
      deletedImages: [],
      loadGallery: false
    }
  },
  methods: {
    getDataById (url, id) {
      this.$axios.post(url + id).then((res) => {
        const data = res.data.welding_procedure
        data.wptwpr_id = res.data.wptwpr
        data.wptwt_id = res.data.wptwt
        data.base_metal = res.data.base_metal
        data.filler_metal = res.data.filler_metal
        data.welding_parameter = res.data.welding_parameter
        this.wpsAsme = data
        this.images = res.data.welding_procedure_drawing
        setTimeout(() => {
          this.wpsAsme.filler_metal.push({ welding_process_id: {}, f_no: '', a_no: '', spec_no: '', aws_class: '', filler_size: '', deposited_weld_metal_thickness: '', groove: '', fillet: '', electrode_flux_class: '', remarks: '' })
          const l = this.wpsAsme.filler_metal.length
          this.wpsAsme.filler_metal.splice((l - 1), 1)
          this.wpsAsme.welding_parameter.push({ welding_process_id: {}, weld_layer: '', filler_class: '', filler_size: '', polarity_id: {}, min_current: '', max_current: '', min_voltage: '', max_voltage: '', min_travel_speed: '', max_travel_speed: '', min_feed_speed: '', max_feed_speed: '', min_flowrate: '', max_flowrate: '' })
          const l1 = this.wpsAsme.welding_parameter.length
          this.wpsAsme.welding_parameter.splice((l1 - 1), 1)
        }, 1000)
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    },
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = this.edit_id ? 'saveWeldingProcedure/' + this.edit_id : 'saveWeldingProcedure'
        this.wpsAsme.type = 'wps_asme'
        this.wpsAsme.images = this.images
        this.wpsAsme.deletedImages = this.deletedImages
        this.$axios.post(route, this.wpsAsme).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/weldingProcedure')
          } else {
            const resData = res.data.data
            this.reset(resData)
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createWpsAsmeForm.validate()
      }
    },
    reset (resData = {}) {
      // when form reset set old prefix and no for continute the sequence
      const oldPrefix = resData.prefix
      const oldSrNo = resData.no
      this.$refs.createWpsAsmeForm.reset()
      setTimeout(() => {
        this.wpsAsme = { prefix: oldPrefix, no: oldSrNo, status: 0, flux: 1, rev_no: 0, rev_date: new Date().toISOString().substr(0, 10), base_metal: [], filler_metal: [], welding_parameter: [], tensile_test: [], guided_bend_test: [], toughness_test: [], other_test: [], hardness_test: [] }
        this.error = {}
        this.images = []
        this.deletedImages = []
        // this.$refs.firstInput.focus()
      }, 300)
    },
    addBaseMetal () {
      this.wpsAsme.base_metal.push({ base_metal: '', grade: '', material_specification: '', p_no: '', group_no: '', thickness: '', groove_thickness_range: '', fillet_thickness_range: '', pipe_diameter_range: '' })
    },
    removeBaseMetal (index) {
      this.wpsAsme.base_metal.splice(index, 1)
    },
    addFillerMetal () {
      this.wpsAsme.filler_metal.push({ welding_process_id: {}, f_no: '', a_no: '', spec_no: '', aws_class: '', filler_size: '', deposited_weld_metal_thickness: '', groove: '', fillet: '', electrode_flux_class: '', remarks: '' })
    },
    removeFillerMetal (index) {
      this.wpsAsme.filler_metal.splice(index, 1)
    },
    bindWeldingProcess (ind) {
      const bindFiller = {}
      bindFiller.id = this.wpsAsme.filler_metal[ind].wps_id
      bindFiller.text = this.wpsAsme.filler_metal[ind].wps_text
      return bindFiller
    },
    addWeldingParameter () {
      this.wpsAsme.welding_parameter.push({ welding_process_id: {}, weld_layer: '', filler_class: '', filler_size: '', polarity_id: {}, min_current: '', max_current: '', min_voltage: '', max_voltage: '', min_travel_speed: '', max_travel_speed: '', min_feed_speed: '', max_feed_speed: '' })
    },
    removeWeldingParameter (ind) {
      this.wpsAsme.welding_parameter.splice(ind, 1)
    },
    bindWpmWeldingProcess (ind) {
      const wpmWeldingProcess = {}
      wpmWeldingProcess.id = this.wpsAsme.welding_parameter[ind].wpm_wps_id
      wpmWeldingProcess.text = this.wpsAsme.welding_parameter[ind].wpm_wps_text
      return wpmWeldingProcess
    },
    bindWpmPolarity (ind) {
      const wpmPolarity = {}
      wpmPolarity.id = this.wpsAsme.welding_parameter[ind].wpm_plr_id
      wpmPolarity.text = this.wpsAsme.welding_parameter[ind].wpm_plr_text
      return wpmPolarity
    },
    uploadImage () {
      this.$refs.file_input_join_drawing.click()
    },
    resetImageUploader () {
      this.$refs.file_input_join_drawing.value = ''
    },
    fileChangeEvent () {
      if (this.$refs.file_input_join_drawing.files.length) {
        const formData = new FormData()
        formData.append('access_token', localStorage.getItem(process.env.VUE_APP_LSACCESSTOKENKEY))
        formData.append('request_from', 'clientApp')
        for (let i = 0; i < this.$refs.file_input_join_drawing.files.length; i++) {
          const file = this.$refs.file_input_join_drawing.files[i]
          formData.append('files[' + i + ']', file)
        }
        this.$axios.post('upload', formData, { removeCommonParams: true, requestForSearchable: true }).then((res) => {
          this.images = [...this.images, ...res.data.files]
        }).catch((err) => {
          console.log(err.response)
        })
      }
    },
    removeImage (i) {
      const image = this.images[i]
      const data = {}
      data.is_new_uploaded = !!image.is_new_uploaded
      data.is_from_gallery = !!image.is_from_gallery
      data.filename = image.name
      data.module = 'welding_procedure'
      this.images.splice(i, 1)
      if (!data.is_new_uploaded && !data.is_from_gallery) {
        const temp = [image]
        this.deletedImages = [...this.deletedImages, ...temp]
        return
      }
      this.$axios.post('deleteUploadImage', data, { mainLoader: false }).then((res) => {})
    },
    getSelectedImage (value) {
      this.images = [...this.images, ...value]
    }
  },
}
</script>

<style>
.createWpsAsmeForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createWpsAsmeForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.logo_box {
  border: 1px dotted #ccc;
  max-width: 200px;
}
.upload_container {
  height: 300px;
  width: 100%;
  position : relative;
}
</style>
